<template>
  <div class="article-detail">
    <div class="article-header">
      <div class="article-title">{{ title }}</div>
      <div class="article-title">{{ translatedTitle }}</div>

      <div class="article-time">
        <slot name="time">{{ $dayjs(data[fields.time]).format('YYYY-MM-DD HH:mm') }}</slot>
      </div>
    </div>

    <slot name="overview"></slot>

    <div class="article-content">
      <slot> </slot>

      <div v-if="data[fields.content]" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import InfoTime from './InfoTime.vue'

export default {
  components: { InfoTime },
  props: {
    data: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: () => {}
    },
    isTranslated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    fields() {
      return {
        title: 'title',
        time: 'time',
        content: 'content',
        ...this.props
      }
    },
    title() {
      if (this.data.lang === 'en' && this.isTranslated) {
        return this.data.title
      }

      return this.isTranslated ? this.data.translatedTitle : this.data.title
    },
    translatedTitle() {
      if (this.data.lang === 'en' && this.isTranslated) {
        return this.data.translatedTitle
      }

      return ''
    },
    content() {
      if (this.data.lang === 'en' && this.isTranslated) {
        const contentParts = this.data.content.split('\n\n')
        const translatedParts = this.data.translatedContent.split('<br/><br/>')
        const result = contentParts.map((c, i) => `${c}\n${translatedParts[i]}`).join('\n\n')

        return result
      }

      return this.isTranslated ? this.data.translatedContent : this.data.content
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.article-detail {
  padding: 0 15px;
  background: var(--bg-color-2);
  .article-header {
    padding: 16px 0;
    font-size: 18px;
    font-weight: 500;
    border-bottom: 1px solid var(--border-color-1);
  }
  .article-title {
    line-height: 33px;
    font-size: 24px;
    font-weight: 900;
  }
  .article-time {
    display: flex;
    padding-top: 8px;
    font-size: 13px;
    line-height: 18px;
    color: var(--font-color-3);
  }
  .article-content {
    padding: 15px 0;
    line-height: 33px;
    font-size: 18px;
    white-space: pre-wrap;
  }
}
</style>
